import { Injectable } from '@angular/core';
import { APIResponse } from '@mommy/models/Comm.model';
import { MemberShippingInfo } from '@mommy/models/MemberShippingInfo.model';
import { Api } from '@mommy/services/api';

@Injectable({
  providedIn: 'root',
})
export class MemberShippingInfoService {
  constructor(private api: Api) {}

  get_list(data?: any): Promise<any> {
    const endpoint = 'v1/member/member-shipping-info';

    return new Promise(async (resolve, reject) => {
      try {
        const result: APIResponse = await (<any>(
          this.api.get(endpoint).toPromise()
        ));
        console.log('result', result);
        if (result.returnCode === 'ERROR') {
          reject(result);
        } else {
          resolve(result.data);
        }
      } catch (error) {
        console.error('member-shipping-info list get error', error);
        reject(error);
      }
    });
  }

  delete(member_shipping_info_id): Promise<any> {
    const endpoint = `v1/member/member-shipping-info/${member_shipping_info_id}`;

    return new Promise(async (resolve, reject) => {
      try {
        const result: APIResponse = await (<any>(
          this.api.delete(endpoint).toPromise()
        ));
        console.log('result', result);
        if (result.returnCode === 'ERROR') {
          reject(result);
        } else {
          resolve(result.data);
        }
      } catch (error) {
        console.error('member-shipping-info delete error', error);
        reject(error);
      }
    });
  }

  add(memberShippingInfo: MemberShippingInfo): Promise<any> {
    const endpoint = `v1/member/member-shipping-info`;

    return new Promise(async (resolve, reject) => {
      try {
        let params: any = {};
        params = memberShippingInfo;

        const result: APIResponse = await (<any>(
          this.api.post(endpoint, params).toPromise()
        ));
        console.log('result', result);
        if (result.returnCode === 'ERROR') {
          reject(result);
        } else {
          resolve(result.data);
        }
      } catch (error) {
        console.error('member-shipping-info add error', error);
        reject(error);
      }
    });
  }

  update(memberShippingInfo: MemberShippingInfo): Promise<any> {
    const endpoint = `v1/member/member-shipping-info/${memberShippingInfo.member_shipping_info_id}`;

    return new Promise(async (resolve, reject) => {
      try {
        const result: APIResponse = await (<any>(
          this.api.put(endpoint, memberShippingInfo).toPromise()
        ));
        console.log('result', result);
        if (result.returnCode === 'ERROR') {
          reject(result);
        } else {
          resolve(result.data);
        }
      } catch (error) {
        console.error('member-shipping-info update error', error);
        reject(error);
      }
    });
  }
}
